/**
 * Marks an English source string for translation. The catalogs in this folder
 * are the complete list `bun run i18n:translate` translates into
 * src/shared/i18n/locales/<locale>.json.
 */
export function msg(source: string): string {
  return source;
}
